/* nm-core.js · tema, carrito Ajax (drawer), toast y barra inferior. Se carga en todas las páginas. */
(function () {
  'use strict';
  var NM = window.NM = window.NM || {};
  var root = document.documentElement;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var S = NM.strings || {};
  NM.themeHooks = [];
  NM.reduce = root.classList.contains('rm');

  var moneyFmt = function (cents) {
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: NM.currency || 'MXN', maximumFractionDigits: (cents % 100 === 0) ? 0 : 2, minimumFractionDigits: (cents % 100 === 0) ? 0 : 2 }).format(cents / 100);
    } catch (e) { return '$' + Math.round(cents / 100); }
  };
  NM.money = moneyFmt;

  /* ---------- menú principal: navegación garantizada ----------
     Si algún script (una app instalada, una transición) cancela el clic de un enlace del menú que va a OTRA página
     (Catálogo, Nootrópicos…), se navega igual. Las anclas de la misma página siguen con su scroll suave. */
  window.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-nav-guard] a[href]'); if (!a) return;
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;
    var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    if (u.hash && u.pathname === location.pathname && u.search === location.search) return;
    setTimeout(function () { if (e.defaultPrevented) location.assign(a.href); }, 0);
  }, true);

  /* ---------- vista previa de un tema no publicado: conserva ?preview_theme_id en los enlaces internos (como hacía el tema anterior de la tienda) ---------- */
  (function () {
    try {
      var th = window.Shopify && window.Shopify.theme, id = th && th.id && String(th.id);
      if (!id || new URLSearchParams(location.search).get('preview_theme_id') !== id) return;
      var patch = function (a) {
        var raw = a.getAttribute && a.getAttribute('href');
        if (!raw || raw.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(raw)) return;
        var u = new URL(a.href, location.origin);
        if (u.origin !== location.origin || /^\/(cart|checkout|account)(\/|$)/.test(u.pathname) || u.searchParams.get('preview_theme_id') === id) return;
        u.searchParams.set('preview_theme_id', id); a.setAttribute('href', u.pathname + u.search + u.hash);
      };
      document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a) patch(a); }, true);
      Array.prototype.forEach.call(document.querySelectorAll('a[href]'), patch);
    } catch (err) {}
  })();

  /* ---------- toast ---------- */
  function toast(m) {
    var el = $('#toast'); if (!el) return;
    el.textContent = m; el.classList.add('on');
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('on'); }, 2800);
  }
  window.toast = NM.toast = toast;

  /* ---------- tema claro / oscuro ---------- */
  var metaTC = $('meta[name=theme-color]'), themeBtn = $('#themeBtn');
  function applyTheme(t) {
    root.dataset.theme = t;
    if (metaTC) metaTC.content = t === 'dark' ? '#041634' : '#EEF8FF';
    if (themeBtn) {
      themeBtn.setAttribute('aria-pressed', t === 'dark');
      themeBtn.setAttribute('aria-label', t === 'dark' ? S.themeLight : S.themeDark);
    }
    Array.prototype.forEach.call(document.querySelectorAll('.mtheme'), function (b) {
      b.setAttribute('aria-pressed', t === 'dark');
      b.setAttribute('aria-label', t === 'dark' ? S.themeLight : S.themeDark);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-theme-set]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-theme-set') === t);
    });
    if (window.__glTheme) window.__glTheme(t);
    NM.themeHooks.forEach(function (f) { f(t); });
  }
  NM.applyTheme = applyTheme;
  function setTheme(t, x, y) {
    try { localStorage.setItem('nm-theme', t); } catch (e) {}
    if (!document.startViewTransition || NM.reduce) { applyTheme(t); return; }
    var r = Math.hypot(Math.max(x, innerWidth - x), Math.max(y, innerHeight - y));
    var vt = document.startViewTransition(function () { applyTheme(t); });
    vt.ready.then(function () {
      root.animate({ clipPath: ['circle(0px at ' + x + 'px ' + y + 'px)', 'circle(' + r + 'px at ' + x + 'px ' + y + 'px)'] },
        { duration: 1000, easing: 'cubic-bezier(.76,0,.24,1)', pseudoElement: '::view-transition-new(root)' });
    }).catch(function () {});
  }
  window.setTheme = setTheme;
  applyTheme(root.dataset.theme || 'light');
  if (themeBtn) themeBtn.addEventListener('click', function (e) {
    var b = e.currentTarget.getBoundingClientRect();
    setTheme(root.dataset.theme === 'dark' ? 'light' : 'dark', b.left + b.width / 2, b.top + b.height / 2);
  });
  /* móvil: botón de ícono en el encabezado (alterna) y fila «Tema: Claro / Oscuro» del menú (elige). Misma persistencia (localStorage nm-theme) */
  document.addEventListener('click', function (e) {
    var m = e.target.closest && e.target.closest('.mtheme, [data-theme-set]');
    if (!m) return;
    var b = m.getBoundingClientRect(), want = m.getAttribute('data-theme-set') || (root.dataset.theme === 'dark' ? 'light' : 'dark');
    if (want !== root.dataset.theme) setTheme(want, b.left + b.width / 2, b.top + b.height / 2);
  });
  if (window.matchMedia) matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
    try { if (localStorage.getItem('nm-theme')) return; } catch (_) {}
    if (NM.defaultTheme === 'auto') applyTheme(e.matches ? 'dark' : 'light');
  });

  /* ---------- carrito (Ajax) ---------- */
  var drawer = $('#cart-drawer');
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('open'); });
    document.body.classList.add('drawer-open');
    /* Lenis captura la rueda del ratón: al abrir el cajón se pausa para que .cd-lines haga scroll nativo */
    try { if (window.lenis && typeof lenis.stop === 'function') lenis.stop(); } catch (e) {}
    var f = $('.cd-close', drawer); if (f) f.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    document.body.classList.remove('drawer-open');
    setTimeout(function () { drawer.hidden = true; }, 350);
    try { if (window.lenis && typeof lenis.start === 'function') lenis.start(); } catch (e) {}
    /* preventScroll: al cerrar, la página no salta; el cliente sigue donde estaba */
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); } }
  }
  NM.openDrawer = openDrawer; NM.closeDrawer = closeDrawer;

  /* Un solo flujo: toda mutación → applySections/renderDrawer + /cart.js → evento 'cart:updated' → UI */
  var SEC = 'cart-drawer';
  function swapDrawer(html) {
    if (!drawer || !html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var inner = $('.cd-inner', tmp), cur = $('.cd-inner', drawer);
    if (!inner || !cur) return;
    var oldBar = $('.cd-free .bar i', cur), oldW = oldBar ? oldBar.style.width : null;
    var st = cur.scrollTop;
    cur.innerHTML = inner.innerHTML;
    cur.scrollTop = st;
    var nb = $('.cd-free .bar i', cur);
    if (nb && oldW !== null) { var tw = nb.style.width; nb.style.transition = 'none'; nb.style.width = oldW; void nb.offsetWidth; nb.style.transition = ''; requestAnimationFrame(function () { nb.style.width = tw; }); }
  }
  function renderDrawer() {
    if (!drawer) return Promise.resolve();
    return fetch(NM.routes.cart + '?sections=' + SEC, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) { swapDrawer(j[SEC]); });
  }
  function updateUI(cart) {
    var n = cart.item_count, t = cart.total_price;
    $$('#count,[data-cart-count]').forEach(function (el) { el.textContent = n; });
    var sc = $('#sCount');
    if (sc) sc.textContent = S.cartTitle.replace('__N__', n) + (n ? ' · ' + moneyFmt(t) : '');
    var st = $('#sTotal'), bar = $('#sBar'), sb = $('#sBtn');
    var thr = NM.freeAt || 0;
    if (st && thr > 0) {
      var f = thr - t;
      st.textContent = n === 0 ? S.freeDefault.replace('__AMOUNT__', moneyFmt(thr)) : (f > 0 ? S.freeMissing.replace('__AMOUNT__', moneyFmt(f)) : S.freeOk);
    }
    if (bar && thr > 0) bar.style.width = Math.min(100, t / thr * 100) + '%';
    if (sb) {
      sb.textContent = n ? S.pay : S.checkout;
      sb.setAttribute('href', n ? (sb.dataset.cartUrl || NM.routes.cart) : (sb.dataset.catalogUrl || '/collections/all'));
      if (n) sb.setAttribute('data-cart-open', ''); else sb.removeAttribute('data-cart-open');
    }
  }
  document.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.cart) updateUI(e.detail.cart); });
  function emit(cart, src) { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: src } })); return cart; }
  function fetchCart() { return fetch(NM.routes.cart + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function refreshCart(src) { return Promise.all([fetchCart(), renderDrawer()]).then(function (a) { return emit(a[0], src || 'refresh'); }); }
  NM.refreshCart = refreshCart;
  function postJSON(url, body) {
    body.sections = SEC; body.sections_url = location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var er = new Error(j.description || j.message || 'error'); er.status = r.status; throw er; } return j; }); });
  }
  function afterMutation(j, src) {
    // Si la respuesta trae la sección, se usa; si no, se pide aparte. El carrito siempre se lee de /cart.js (sin caché).
    var hasSec = j && j.sections && j.sections[SEC];
    if (hasSec) swapDrawer(j.sections[SEC]);
    return Promise.all([fetchCart(), hasSec ? null : renderDrawer()]).then(function (a) { return emit(a[0], src); });
  }

  function addItems(items, label, code) {
    return postJSON(NM.routes.cartAdd + '.js', { items: items })
      .then(function (j) {
        var p = code ? fetch(NM.routes.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(NM.routes.cart), { redirect: 'manual' }).catch(function () {}) : Promise.resolve();
        return p.then(function () { return code ? refreshCart('add') : afterMutation(j, 'add'); });
      })
      .then(function () {
        if (NM.cartType === 'page') { location.href = NM.routes.cart; return; }
        /* el carrito abierto ya confirma; el aviso solo sale si no hay carrito lateral */
        if (drawer) openDrawer(); else toast((S.added || '').replace('__NAME__', label || ''));
      })
      .catch(function (e) { toast(e && e.message ? e.message : S.errorAdd); refreshCart('error').catch(function () {}); });
  }
  NM.addItems = addItems;

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form.nm-add-form'); if (!f) return;
    e.preventDefault();
    var fd = new FormData(f), id = +fd.get('id'), q = +fd.get('quantity') || 1;
    var btn = f.querySelector('button[type=submit]'); if (btn) btn.disabled = true;
    var name = f.dataset.name || '';
    addItems([{ id: id, quantity: q }], name).then(function () { if (btn) btn.disabled = false; });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bundle]');
    if (b) {
      e.preventDefault();
      var d = JSON.parse(b.dataset.bundle);
      var items = d.items.map(function (id) { return { id: id, quantity: 1, properties: { Rutina: d.name } }; });
      b.disabled = true;
      addItems(items, d.name, d.code).then(function () { b.disabled = false; });
      return;
    }
    var o = e.target.closest('[data-cart-open]');
    if (o && drawer && NM.cartType !== 'page' && !document.body.classList.contains('tpl-cart')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    var chg = e.target.closest('[data-line-change]');
    if (chg) {
      e.preventDefault();
      changeLine(+chg.dataset.line, +chg.dataset.qty, chg);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer(); });
  /* P6 (igual que tienda-fixes/nm-fixes.js) · Página del carrito y ficha: «Seguir comprando» regresa a la página anterior
     de la tienda (si la hay) en lugar de ir al catálogo; sin historial, el enlace lleva al catálogo. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cart-back], .pdp-back a.tlink');
    if (!a) return;
    try {
      var ref = document.referrer ? new URL(document.referrer) : null;
      if (ref && ref.origin === location.origin && ref.pathname !== location.pathname && history.length > 1) { e.preventDefault(); history.back(); }
    } catch (_) {}
  });

  var busy = false;
  function changeLine(line, qty, btn) {
    if (busy) return;
    busy = true;
    var panel = drawer && $('.cd-panel', drawer);
    if (panel) panel.classList.add('is-busy');
    var keep = btn && btn.getAttribute('aria-label');
    if (btn) btn.disabled = true;
    postJSON(NM.routes.cartChange + '.js', { line: line, quantity: qty })
      .then(function (j) { return afterMutation(j, 'change'); })
      .then(function (c) {
        if (document.body.classList.contains('tpl-cart')) { location.reload(); return; }
        // devolver el foco a un control equivalente tras re-renderizar
        if (keep && drawer) { var nb = $$('[data-line-change]', drawer).filter(function (x) { return x.getAttribute('aria-label') === keep; })[0]; (nb || $('.cd-close', drawer)).focus(); }
        if (c && qty > 0) { var it = c.items[line - 1]; if (it && it.quantity < qty) toast(S.errorStock || ''); }
      })
      .catch(function (e) { toast(e && e.message ? e.message : S.errorAdd); return refreshCart('error'); })
      .then(function () { busy = false; if (panel) panel.classList.remove('is-busy'); });
  }

  /* ---------- barra inferior: visible tras el hero (portada) o siempre (resto) ---------- */
  var sticky = $('#sticky');
  if (sticky) {
    var hero = $('#hero');
    if (hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (a) { var en = a[0]; sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); }, { threshold: 0 }).observe(hero);
    } else if (!document.body.classList.contains('tpl-cart')) sticky.classList.add('show');
  }
})();

/* Boletín: copiar código + foco al panel de éxito */
(function(){
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-copy]');if(!b)return;
    var t=b.getAttribute('data-copy'),lbl=b.textContent;
    var done=function(){b.textContent=b.getAttribute('data-copied')||'OK';b.classList.add('is-done');setTimeout(function(){b.textContent=lbl;b.classList.remove('is-done')},2200)};
    if(navigator.clipboard&&window.isSecureContext){navigator.clipboard.writeText(t).then(done,function(){fb()})}else fb();
    function fb(){var a=document.createElement('textarea');a.value=t;a.setAttribute('readonly','');a.style.position='fixed';a.style.opacity='0';document.body.appendChild(a);a.select();try{document.execCommand('copy');done()}catch(_){}document.body.removeChild(a)}
  });
  var ok=document.querySelector('[data-nl-ok]');
  if(ok){var go=function(){var f=document.getElementById('footer-newsletter');if(f){if(window.lenis)lenis.scrollTo(f,{offset:-110,immediate:true,force:true});else f.scrollIntoView({block:'center'});}ok.focus({preventScroll:true})};
    if(document.readyState==='complete')setTimeout(go,60);else window.addEventListener('load',function(){setTimeout(go,60)});}
})();

/* Entrada al hacer scroll ([data-reveal] → .is-in) + pestañas del catálogo (flechas y bordes) */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('[data-reveal]');
  if (els.length && 'IntersectionObserver' in window && !reduce) {
    document.documentElement.classList.add('js-rv');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-tabs]'), function (w) {
    var t = w.querySelector('[data-tabs-track]'); if (!t) return;
    function upd() {
      var max = t.scrollWidth - t.clientWidth;
      w.classList.toggle('has-l', t.scrollLeft > 4);
      w.classList.toggle('has-r', t.scrollLeft < max - 4);
    }
    function by(dir) { t.scrollBy({ left: dir * t.clientWidth * 0.7, behavior: reduce ? 'auto' : 'smooth' }); }
    var l = w.querySelector('[data-tabs-prev]'), r = w.querySelector('[data-tabs-next]');
    if (l) l.addEventListener('click', function () { by(-1); });
    if (r) r.addEventListener('click', function () { by(1); });
    t.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    var cur = t.querySelector('[aria-current="page"]');
    if (cur) { var x = cur.offsetLeft - t.clientWidth / 2 + cur.offsetWidth / 2; if (x > 0) t.scrollLeft = x; }
    upd();
  });
})();

/* Menú móvil/tablet: abrir/cerrar, Escape, foco, cierre al navegar */
(function () {
  var b = document.getElementById('navBtn'), p = document.getElementById('mnav'); if (!b || !p) return;
  var root = document.documentElement;
  function set(open) {
    b.setAttribute('aria-expanded', String(open)); b.setAttribute('aria-label', open ? b.dataset.close : b.dataset.open);
    root.classList.toggle('mnav-on', open);
    if (open) { p.hidden = false; requestAnimationFrame(function () { p.classList.add('open'); }); var f = p.querySelector('a'); if (f) f.focus({ preventScroll: true }); }
    else { p.classList.remove('open'); setTimeout(function () { if (b.getAttribute('aria-expanded') === 'false') p.hidden = true; }, 240); }
  }
  b.addEventListener('click', function () { set(b.getAttribute('aria-expanded') !== 'true'); });
  /* Tema desde el panel (en pantallas muy angostas el interruptor del encabezado se oculta) */
  Array.prototype.forEach.call(p.querySelectorAll('[data-theme-proxy]'), function (t) { t.addEventListener('click', function () { var tb = document.getElementById('themeBtn'); if (tb) tb.click(); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && b.getAttribute('aria-expanded') === 'true') { set(false); b.focus(); } });
  p.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
  matchMedia('(min-width:1101px)').addEventListener('change', function (m) { if (m.matches) set(false); });
})();

/* Catálogo: «Ordenar por» (y cualquier filtro con data-autosort/data-autosubmit) se aplica al cambiar, sin botón.
   Conserva los demás parámetros de la URL (filtros, búsqueda) y vuelve a la página 1. */
(function () {
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('select[data-autosort]');
    if (s) {
      var u = new URL(location.href); u.searchParams.set(s.name || 'sort_by', s.value); u.searchParams.delete('page');
      var w = s.closest('.ch-sort'); if (w) w.classList.add('is-busy');
      location.assign(u.pathname + u.search + u.hash); return;
    }
    var f = e.target.closest && e.target.closest('form[data-autosubmit]');
    if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
  });
})();

/* Pestañas del catálogo: popover «Más» */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-tabs-more]'), function (w) {
    var b = w.querySelector('.ch-more-b'), p = w.querySelector('.ch-more-p'); if (!b || !p) return;
    function set(o) {
      b.setAttribute('aria-expanded', String(o)); p.hidden = !o;
      document.documentElement.classList.toggle('ch-more-open', o);
      if (o && p.parentNode !== document.body) document.body.appendChild(p);
      if (!p.hidden) { var a = p.querySelector('a'); if (a) a.focus(); }
    }
    b.addEventListener('click', function (e) { e.stopPropagation(); set(p.hidden); });
    document.addEventListener('click', function (e) { if (!w.contains(e.target) && !p.contains(e.target)) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !p.hidden) { set(false); b.focus(); } });
  });
})();
